<script>
export default {
    name: 'IconPoi',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-poi"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 8c8.837 0 16 7.163 16 16 0 5.891-5.333 16.558-16 32-10.667-15.442-16-26.109-16-32 0-8.837 7.163-16 16-16zm0 10a6 6 0 100 12 6 6 0 000-12z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
